<template>
    <fragment v-if="shipment.dangerousGoods">
      <b-form-group
          label-cols-sm="4"
          :label="$t('createShipment.label.PackingGroup')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="10">
            <vSelect
                :dynamic-width="true"
                size="sm"
                name="dangerousGoodsPackingGroup"
                :options="packingGroups"
                :select-on-tab="true"
                :placeholder="$t('createShipment.placeholder.Choose Packing Group')"
                label="dangerousGoodsPackingGroup"
                v-model="shipment.dangerousGoods.packingGroup"
                :class="
                                'dangerous-goods-dropdown ' +
                                    {
                                        'is-invalid': v.shipment.dangerousGoods.packingGroup.$error
                                    }
                            "
                @update="v.shipment.dangerousGoods.packingGroup.$touch()"
                :clearable="false"
            />

            <validationField
                fieldName="createShipment.label.PackingGroup"
                :validator="v.shipment.dangerousGoods.packingGroup"
                name="dangerousGoodsPackingGroup.error"
                v-if="v.shipment.dangerousGoods.packingGroup.$error"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
    </fragment>
</template>
<script>
import viewOptions from "@/mixins/viewOptionsMixin";
import resetMixin from "@/mixins/resetMixin";
import vSelect from "@/components/vSelect";
import validationField from "@/components/Validation/ValidationField";
import requiredIcon from "@/components/requiredIcon";
import {Fragment} from 'vue-fragment'

export default {
  components:{
    vSelect,
    validationField,
    requiredIcon,
    Fragment
  },
  props:{
    shipment: {required: true},
    v: {required:true}
  },
  mixins:[viewOptions, resetMixin],
  data(){
    return {
      packingGroups: ["I", "II", "III"]
    }
  },
  methods:{
    
  },
  computed:{
    
  }
}
</script>
<style>

</style>